/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Total_Budget_Strip_LabelInputs */



/**
* | output |
* | --- |
* | "Total budget this billing period" |
*
* @param {Usage_Total_Budget_Strip_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_total_budget_strip_label = /** @type {((inputs?: Usage_Total_Budget_Strip_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Total_Budget_Strip_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtbudget dieser Abrechnungsperiode")
	return /** @type {LocalizedString} */ ("Total budget this billing period")
});